import './Notifications.scss';

import type { NotificationToRender } from 'common/models';
import { NotificationItem } from 'components';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

interface OwnProps {
  notifications: NotificationToRender[];
  title?: string;
  onClose?: () => void;
}

const NotificationsList = (props: OwnProps) => {
  const { notifications, title, onClose } = props;
  const { t } = useCustomTranslation();

  return (
    <div className="NotificationsList">
      {title && <div className="NotificationsList_title">{title}</div>}
      {notifications.length > 0 ? (
        notifications.map((item) => (
          <NotificationItem onClose={onClose} key={item.id} notification={item} />
        ))
      ) : (
        <div className="text-center">{t('notifications.noData')}</div>
      )}
    </div>
  );
};

export default NotificationsList;
